/** The tutorial's own words (its steps are the extension's), merged into the app's translation namespace on import. */
import i18n from '@/app/i18n'

const strings: Record<string, Record<string, string>> = {
    en: {
        'tutorial.show': 'Show tutorial',
        'tutorial.next': 'Next',
        'tutorial.back': 'Back',
        'tutorial.done': 'Done',
        'tutorial.skip': 'Skip',
    },
    et: {
        'tutorial.show': 'Näita õpetusi',
        'tutorial.next': 'Edasi',
        'tutorial.back': 'Tagasi',
        'tutorial.done': 'Valmis',
        'tutorial.skip': 'Jäta vahele',
    },
    de: {
        'tutorial.show': 'Tutorial anzeigen',
        'tutorial.next': 'Weiter',
        'tutorial.back': 'Zurück',
        'tutorial.done': 'Fertig',
        'tutorial.skip': 'Überspringen',
    },
    ru: {
        'tutorial.show': 'Показать обучение',
        'tutorial.next': 'Далее',
        'tutorial.back': 'Назад',
        'tutorial.done': 'Готово',
        'tutorial.skip': 'Пропустить',
    },
}

for (const [language, bundle] of Object.entries(strings)) {
    i18n.addResourceBundle(language, 'translation', bundle, true, false)
}
